import { useState } from "react";
import CRM_API from "../../api/crmApi";

export default function CrmBulkUpload() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first");
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      const res = await CRM_API.post("/dashboard/upload-leads", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(res.data);
      setFile(null);
    } catch (err) {
      alert(
        err.response?.data?.error ||
        err.response?.data?.detail ||
        "Upload failed"
      );
    } finally {
      setLoading(false);
    }
  };

  const downloadTemplate = async () => {
    try {
      const res = await CRM_API.get("/dashboard/download-template", {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "lead_template.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Template download failed");
    }
  };

  return (
    <div>
      <h4 className="fw-bold mb-4">Bulk Upload Leads</h4>

      <div className="card shadow-sm" style={{ maxWidth: "520px" }}>
        <div className="card-body p-4">

          {/* Drop zone */}
          <label
            style={{
              display: "flex", flexDirection: "column", alignItems: "center",
              border: "2px dashed #d1d5db", borderRadius: "12px",
              padding: "32px 24px", cursor: "pointer", marginBottom: "20px",
              background: "#f9fafb", transition: "border-color .15s",
            }}
          >
            <i
              className="bi bi-cloud-upload"
              style={{ fontSize: "38px", color: "#9ca3af", marginBottom: "10px" }}
            />
            <span style={{ color: "#6b7280", fontSize: "14px" }}>
              Click to upload Excel / CSV
            </span>
            <input
              type="file"
              accept=".xlsx,.csv"
              onChange={(e) => { setFile(e.target.files[0]); setResult(null); }}
              style={{ display: "none" }}
            />
            {file && (
              <span
                style={{
                  marginTop: "10px", fontSize: "13px",
                  color: "#4f46e5", fontWeight: 600,
                }}
              >
                {file.name}
              </span>
            )}
          </label>

          {/* Buttons */}
          <div className="d-flex gap-3">
            <button
              onClick={handleUpload}
              disabled={loading}
              className="btn btn-primary flex-fill"
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Uploading...
                </>
              ) : (
                <><i className="bi bi-upload me-2" />Upload Leads</>
              )}
            </button>
            <button onClick={downloadTemplate} className="btn btn-success flex-fill">
              <i className="bi bi-file-earmark-excel me-2" />Download Template
            </button>
          </div>

          <p className="text-muted text-center mt-3 mb-0" style={{ fontSize: "12px" }}>
            Supported: <strong>.xlsx / .csv</strong>&nbsp;|&nbsp;
            Required columns: <strong>name, mobile</strong>
          </p>

          {result && (
            <div className="alert alert-success mt-3 mb-0">
              <i className="bi bi-check-circle me-2" />
              {result.message}
              <div className="mt-1" style={{ fontSize: "12px" }}>
                Inserted: <strong>{result.inserted}</strong>&nbsp;|&nbsp;
                Skipped: <strong>{result.skipped}</strong>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
